export async function startGame(options) {
    options.headers = {
        ...options.headers,
    }
    const url = `${process.env.REACT_APP_API_URL}/ai/service/start_game`
    const response = await fetch(url, options)
    if(response.status === 200 ){
        // console.log(response,'setQuestionsetQuestionsetQuestion')
        return response
    }
    if(response.status == 400){
        // localStorage.removeItem('aiOrNot')
        return response
    }else{
        throw new Error('Error')
    }
}

export async function submitAnswer(options) {
    options.headers = {
        ...options.headers,
    }
    const url = `${process.env.REACT_APP_API_URL}/ai/service/submit_answer`
    const response = await fetch(url, options)
    if(response.status === 200 || response.status === 400){
        return response
    }else{
        throw new Error('Error')
    }
}

